module.exports = __webpack_public_path__ + "2524388a712648e76a8969115f5bb77a.pdf";